let m = $('#password-modal');
// $('.modal').modal()

$('button.password-required').on('click', e => {
  e.preventDefault();
  let password = $('input[type="password"]').val();
  if (password !== '') {
    fetch('/account/password-validate/', { method: 'POST', body: JSON.stringify({password: password}) }).then(r => r.json()).then(password => {
      if (password.success === true) {
        $(this).parents('form:first').submit();
        $('input[type="password"]').removeClass('is-invalid');
      } else {
        let errors = password.errors;
        $('input[type="password"]').addClass('is-invalid');
        $('.invalid-feedback').html(() => errors.map(error => `<li>${error}</li>`).join(''));
      }
    });
    $('input[type="password"]').removeClass('is-invalid');
  } else {
    m.modal();
    $('input[type="password"]').addClass('is-invalid');
  }
});

$('button.no-password').on('click', e => {
  $('input[type="password"]').val('');
  $('input[type="password"]').removeClass('is-invalid');
});

$('.modal-close').on('click', e => {
  m.modal('toggle');
});
